import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFB9D1EA" },
};

const COLUMN_HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD9D9D9" },
};

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const COL_START = 4; // D
const COL_END = 9; // I
const TITLE_ROW = 3;
const SUBTITLE_ROW = 4;
const HEADER_ROW = 5;
const DATA_START_ROW = 6;

const SUBTITLE_TEXT =
  "Please indicate material responsible business conduct and sustainability issues pertaining to environmental and social matters that present a risk or an opportunity to your business, rationale for identifying the same, approach to adapt or mitigate the risk along-with its financial implications, as per the following format";

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function setMergedHeaderCell(ws, row, text, options = {}) {
  ws.mergeCells(row, COL_START, row, COL_END);
  const cell = ws.getCell(row, COL_START);
  cell.value = text;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  if (options.fill) cell.fill = options.fill;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: "middle",
    wrapText: true,
  };
  ws.getRow(row).height = options.height || 18;
}

export function buildBusinessConductIssuesSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Business conduct issues", {
    views: [{ showGridLines: true }],
  });

  const widths = { A: 2, B: 2, C: 2, D: 8, E: 24, F: 24, G: 24, H: 24, I: 24 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  addSheetBackLink(ws, PARENT_SHEETS.GENERAL_DISCLOSURES, { mergeEnd: COL_END });

  const issues = sectionA?.transparencyAndDisclosures?.materialIssues || [];

  setMergedHeaderCell(
    ws,
    TITLE_ROW,
    "Overview of the entity's material responsible business conduct issues",
    { bold: true, fill: HEADER_FILL }
  );
  setMergedHeaderCell(ws, SUBTITLE_ROW, SUBTITLE_TEXT, { align: "left", height: 40 });

  const headers = [
    { col: COL_START, label: "Sr. No." },
    { col: 5, label: "Material issue identified" },
    { col: 6, label: "Indicate whether risk or opportunity (R/O)" },
    { col: 7, label: "Rationale for identifying the risk / opportunity" },
    { col: 8, label: "In case of risk, approach to adapt or mitigate" },
    {
      col: COL_END,
      label:
        "Financial implications of the risk or opportunity (Indicate positive or negative implications)",
    },
  ];

  headers.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { bold: true, fill: COLUMN_HEADER_FILL, align: "center" });
  });

  const rows = issues.length ? issues : [{}];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_START, String(idx + 1), { align: "center" });
    setCell(ws, row, 5, item?.issueIdentify ?? "", { align: "left" });
    setCell(ws, row, 6, item?.riskOrOpportunity ?? "", { align: "center" });
    setCell(ws, row, 7, item?.rationale ?? "", { align: "left" });
    setCell(ws, row, 8, item?.mitigationApproach ?? "", { align: "left" });
    setCell(ws, row, COL_END, item?.financialImplications ?? "", { align: "left" });
  });

  return ws;
}
